export default __webpack_public_path__ + "static/media/04.4fcce6e0.jpg";